var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"re-kiosk",class:['kiosk', ("" + (_vm.$route.name)), ("" + _vm.locale)]},[_c('KioskReHeader',{attrs:{"max_count":_vm.login_count}}),_c('router-view',{on:{"payment_count":_vm.countModify}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }